import { Flex } from 'antd'
import React from 'react'
import { BillingCard } from '../../subscription/components/billing-card'
import { MessageOverageSettingsCard } from '../../subscription/components/message-overage-settings-card'
import { OverageSettingsCard } from '../../subscription/components/overage-settings-card'
import { PaymentCard } from '../../subscription/components/payment-card'
import { StripePortalButton } from '../../subscription/components/stripe-portal-button'
import { UpdateBillingCard } from '../../subscription/components/update-billing-card'
import { useAuth } from '../../auth'
import { SUBSCRIBE } from '../../user/permission'
import { useNavigate } from '@tanstack/react-router'

type CompanySettingsProps = {
    upgrade?: boolean
}

export function CompanySettings({ upgrade }: CompanySettingsProps) {
    const { can, onTrial } = useAuth()
    const navigate = useNavigate()

    const handleUpgradeClick = () => {
        // Move this up higher in the tree
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        navigate({ search: { upgrade: true } })
    }

    const handleCloseModal = () => {
        // Move this up higher in the tree
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        navigate({ search: {} })
    }

    return (
        <Flex
            gap="large"
            vertical
        >
            <Flex
                gap="large"
                className="flex-col md:flex-row"
            >
                <Flex
                    vertical
                    gap="large"
                    className="md:max-w-96 w-full"
                >
                    {can(SUBSCRIBE) && (
                        <>
                            <BillingCard
                                upgrade={upgrade}
                                onUpgradeClick={handleUpgradeClick}
                                onCloseModal={handleCloseModal}
                            />
                            {!onTrial && <OverageSettingsCard />}
                            {!onTrial && <MessageOverageSettingsCard />}
                            <PaymentCard />
                            <StripePortalButton />
                        </>
                    )}
                </Flex>
                {can(SUBSCRIBE) && <UpdateBillingCard />}
            </Flex>
        </Flex>
    )
}
